import { motion } from "motion/react";

const services = [
  {
    title: "Persianas",
    desc: "Reparación, motorización e instalación de persianas enrollables, de aluminio, PVC y madera. Cambio de cinta, lamas, ejes y motores Somfy.",
  },
  {
    title: "Toldos",
    desc: "Instalación y reparación de toldos extensibles, cofre, brazo invisible y pérgolas. Lonas de repuesto, motorización y automatización.",
  },
  {
    title: "Mosquiteras",
    desc: "Mosquiteras enrollables, correderas, fijas y plisadas a medida. Instalación express en puertas y ventanas de cualquier tamaño.",
  },
];

export default function WhatWeDoSection() {
  return (
    <section className="bg-white pt-6 pb-16 md:pt-8 md:pb-20">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: image */}
          <motion.div
            className="w-full lg:w-1/2 relative"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            <div className="relative rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://storage.readdy-site.link/project_files/cf1847c3-949c-4dd2-b2c0-64bc50d47abe/0a7f0a03-18fb-4933-b8cb-d9a2a9bef997_reparateur.jpg?v=014247db94de1f118941c5bf1898e461"
                alt="Técnico de Persianas Toldos Málaga instalando una persiana en una vivienda de la Costa del Sol"
                className="w-full h-auto object-cover aspect-[4/3] scale-x-[-1]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent pointer-events-none" />
            </div>

            {/* Floating badge */}
            <motion.div
              className="absolute -bottom-5 -right-2 md:bottom-6 md:-right-6 bg-white rounded-2xl shadow-lg border border-border p-4 md:p-5 flex items-center gap-3"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary text-xl shrink-0">
                <i className="ri-tools-line" />
              </div>
              <div>
                <p className="font-heading font-bold text-text-primary text-sm md:text-base">+10 años</p>
                <p className="font-body text-text-secondary text-xs md:text-sm">de experiencia</p>
              </div>
            </motion.div>
          </motion.div>

          {/* Right: text */}
          <motion.div
            className="w-full lg:w-1/2 flex flex-col gap-6"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            <div className="inline-flex items-center gap-2 bg-surface-alt text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
              <i className="ri-hammer-line text-primary" />
              ¿Qué hacemos?
            </div>

            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary leading-tight">
              Reparamos, motorizamos e instalamos persianas, toldos y mosquiteras en Málaga
            </h2>

            <p className="font-body text-base md:text-lg text-text-secondary leading-relaxed">
              Somos una empresa local con taller en San Andrés, Málaga. No subcontratamos: nuestro propio técnico se desplaza a tu domicilio en menos de 24 horas para reparar, motorizar o instalar cualquier tipo de persiana, toldo o mosquitera.
            </p>

            <div className="flex flex-col gap-5 mt-2">
              {services.map((s, i) => (
                <motion.div
                  key={s.title}
                  className="flex items-start gap-4"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 * i }}
                >
                  <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0 mt-0.5">
                    <span className="font-heading font-bold text-sm">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-1">
                      {s.title}
                    </h3>
                    <p className="font-body text-sm md:text-base text-text-secondary leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3 mt-2">
              <a
                href="/persianas"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-semibold text-sm px-5 py-3 rounded-pill transition-colors whitespace-nowrap"
              >
                Ver persianas <i className="ri-arrow-right-line" />
              </a>
              <a
                href="/toldos"
                className="inline-flex items-center gap-2 bg-white hover:bg-slate-50 text-text-primary font-body font-semibold text-sm px-5 py-3 rounded-pill border border-border transition-colors whitespace-nowrap"
              >
                Ver toldos <i className="ri-arrow-right-line" />
              </a>
              <a
                href="/mosquiteras"
                className="inline-flex items-center gap-2 bg-white hover:bg-slate-50 text-text-primary font-body font-semibold text-sm px-5 py-3 rounded-pill border border-border transition-colors whitespace-nowrap"
              >
                Ver mosquiteras <i className="ri-arrow-right-line" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}